import { PrivateSpace } from '@weblite/ts-action/private-space'
import { createKeyvalStorage, createKeyvalView } from '../lib/keyval.storage'

const key = 'private-space'

const storage = createKeyvalStorage<PrivateSpace>(key)

export const privateSpaceStorage = {
  ...storage,
  del() {
    // we should never delete private space storage
    // The user should always be able to open private space from my-account page
  },
}

export const privateSpaceView = createKeyvalView<PrivateSpace>(key)
